import { Component, OnInit, Input, AfterViewInit, SimpleChanges, OnChanges } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
// import { EmergencyDeskService } from 'src/app/emergencydesk/emergencydesk.service';
import * as decode from 'google-polyline/lib/decode';
declare var google: any;
// var decode = require('google-polyline/lib/decode');

@Component({
    selector: 'app-polyline',
    templateUrl: './polyline.component.html',
    styleUrls: ['./polyline.component.scss'],
    standalone: false
})
export class PolylineComponent implements OnInit, AfterViewInit, OnChanges {
  @Input('longitude') longitude: any;
  @Input('latitude') latitude: any;
  @Input('gmap-height') gmapHeight: any;
  @Input('gmap-width') gmapWidth: any;
  @Input() class_map: any = "map-container-ambulance"
  @Input() type: any;
  @Input() name: any;
  // polyLineData: any;
  @Input() polyLineData: any;

  constructor(private baseService: BaseService
  ) { }

  ngOnInit() {


  }
  ngOnChanges(change: SimpleChanges) {
    if (!change['polyLineData'].isFirstChange()) {
      console.log("poly here")
      document.getElementById(this.name).style.height = this.gmapHeight;
      document.getElementById(this.name).style.width = this.gmapWidth;
      if (this.type == 'position') {
        this.initMap(this.longitude, this.latitude);
      } else {
        // this.latLong.getlatLong().subscribe(result => {
        // this.polyLineData = result
        var polylineLat = []
        console.log(this.polyLineData, 'polylinedata');

        var s = decode(this.polyLineData)
        for(let i = 0; i < s.length; i++) {
          var Obj = {}
          Obj['lat'] = s[i][0];
          Obj['lng'] = s[i][1];
          polylineLat.push(Obj);
        }
        var bound = new google.maps.LatLngBounds();
        for (let i = 0; i < polylineLat.length; i++) {
          bound.extend(new google.maps.LatLng(polylineLat[i]['lat'], polylineLat[i]['lng']));
        }
        var center = bound.getCenter()
        // console.log(bound.getCenter());
        this.initPolylineMap(polylineLat, center, bound);
        // })
      }
    }
  }
  ngAfterViewInit() {
    this.baseService.getloadScript$(() => {
      this.processData();
    })


  }

  initMap(long, lat) {
    var googleMap = document.getElementById(this.name);

    var position = new google.maps.LatLng(lat, long);
    let mapProp = {
      center: position,
      zoom: 5,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      streetViewControl: false,
      mapTypeControl: false

    };
    var map = new google.maps.Map(googleMap, mapProp);
    var marker = new google.maps.Marker({ position: position, map: map });
  }

  initPolylineMap(polylineLat: any, center: any, bound: any) {

    console.log("polylineLat - ", polylineLat)
    var map2 = new google.maps.Map(document.getElementById(this.name), {
      zoom: 16,
      center: center,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    });
    var flightPlanCoordinates = polylineLat;
    var ambulancePath = new google.maps.Polyline({
      path: flightPlanCoordinates,
      geodesic: true,
      strokeColor: '#2196f3',
      strokeOpacity: 0.6,
      strokeWeight: 5
    });
    map2.fitBounds(bound);
    console.log(this.latitude, 'lng:', this.longitude)
    var startMarker = new google.maps.Marker({ position: { lat: this.latitude, lng: this.longitude }, map: map2, icon: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABQklEQVRIie2UvU4CURCFv7mS+NtQyRLtfAQ7loTSmPUFjDE2JvZUFkYtxHfQCmJHu2/gLX0BH4CfDgsTYwI7Fu6SFRZYVmzU092Zc+fMmfsDfw5tr1zreO5r+6B0k4Zv5hUQtAqsi0o1HR9o77t7YrgHtuYVjOFdoLG5a8/kiiAKGgAx3H2zOMCywmn3yT2KB6MRbWet6vhWHN8KqiefEbnQSiU3KjB9cwoU1ooPwDPoTnejf5hKYB5IszlA9TZcDV0kCox2ntZJkouFOYDQBdTC5TmE17TjuZq0Iep6Un4WHN/KQh0kITctmbXzOH7cwe8RsGMJNaXAiDuzwGTeI4SH7Pi2HEU7ntsCiv0lHT4sgVbBt18+w7S8sREpNABMoNYEagEC0XpW3tg17a32LvNveQSOBTQQrfdWXq6z8v4xEx8gjIJoAEpIWgAAAABJRU5ErkJggg==' });
    var endMarker = new google.maps.Marker({ position: polylineLat[polylineLat.length - 1], map: map2, icon: 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png' });


    // startMarker.setMap(map2);
    // endMarker.setMap(map2);
    ambulancePath.setMap(map2);

  }

  processData() {
    setTimeout(() => {

      document.getElementById(this.name).style.height = this.gmapHeight;
      document.getElementById(this.name).style.width = this.gmapWidth;
      if (this.type == 'position') {
        this.initMap(this.longitude, this.latitude);
      } else {
        // this.latLong.getlatLong().subscribe(result => {
        // this.polyLineData = result
        var polylineLat = []
        console.log(this.polyLineData, 'polylinedata');

        var s = decode(this.polyLineData)
        for(let i = 0; i < s.length; i++) {
          var Obj = {}
          Obj['lat'] = s[i][0];
          Obj['lng'] = s[i][1];
          polylineLat.push(Obj);
        }
        if (google) {
          var bound = new google.maps.LatLngBounds();
          for (let i = 0; i < polylineLat.length; i++) {
            bound.extend(new google.maps.LatLng(polylineLat[i]['lat'], polylineLat[i]['lng']));
          }
        }
        var center = bound.getCenter()
        // console.log(bound.getCenter());
        this.initPolylineMap(polylineLat, center, bound);
        // })
      }
    })
  }
}